import { createContext, useContext } from "react";

const MarketingAuthUiContext = createContext({
  openLogin: () => {},
  openRegister: () => {},
  closeAuth: () => {},
});

export function MarketingAuthUiProvider({ value, children }) {
  return (
    <MarketingAuthUiContext.Provider value={value}>
      {children}
    </MarketingAuthUiContext.Provider>
  );
}

export function useMarketingAuthUi() {
  return useContext(MarketingAuthUiContext);
}
